module.exports = __webpack_public_path__ + "static/img/3j.8ce5f7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3j.jpg
// module id = yuvl
// module chunks = 0